import Component from '../app/component';
import api from '../helpers/api';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      cart: null,
      cartId: null,
      disabled: false,
      display: false
    };
  }

  init() {
    document.addEventListener('cart.toggle', () => {
      this.data.display = !this.data.display;
    });
    document.addEventListener('cart.update', () => {
      this.updateCart();
      document.dispatchEvent(new CustomEvent('top.tweencart'));
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    this.el.classList.add('cart--active');
    if (this.refs.closeLink) {
      this.refs.closeLink.addEventListener('click', () => {
        this.data.display = !this.data.display;
      });
    }

    const cartId = localStorage.getItem('cartId');
    if (cartId) {
      this.data.cartId = cartId;
      this.updateCart();
    } else {
      this.createCart();
    }
  }

  watchDisabled(value) {
    if (value) {
      this.el.classList.add('cart--disabled');
    } else {
      this.el.classList.remove('cart--disabled');
    }
  }

  watchDisplay(value) {
    if (value) {
      this.el.classList.add('cart--display');
    } else {
      this.el.classList.remove('cart--display');
    }
  }

  updateCart() {
    if (this.data.cartId) {
      this.getCart(this.data.cartId).then((res) => {
        if (res?.result?.data?.cart) {
          this.data.cart = res.result.data.cart;
        } else {
          this.createCart();
        }
      });
    } else {
      this.createCart();
    }
  }

  getCart(cartId) {
    return api.fetch('/api/cart/get', { cartId });
  }

  createCart() {
    api
      .fetch('/api/cart/create', {})
      .then((res) => {
        if (res?.result?.data?.cartCreate?.cart?.id) {
          this.data.cartId = res.result.data.cartCreate.cart.id;
          this.data.cart = res.result.data.cartCreate.cart;
        }
      });
  }

  addLine() {}

  removeLine(lineId) {
    return api.fetch(
      '/api/cart/removeline',
      {
        variables: JSON.stringify({
          cartId: this.data.cartId,
          lineIds: [lineId]
        })
      }
    );
  }

  updateLine(lineId, quantity) {
    return api.fetch(
      '/api/cart/updateline',
      {
        variables: JSON.stringify({
          cartId: this.data.cartId,
          lines: [{
            id: lineId,
            quantity
          }]
        })
      }
    );
  }

  setListeners() {
    Array
      .from(this.refs.list.querySelectorAll('.cart-item-quantity-minus'))
      .forEach((el) => {
        el.addEventListener('click', () => {
          const quantity = parseInt(el.parentNode.querySelector('.cart-item-quantity-value').textContent, 10);
          if (quantity - 1 > 0) {
            this.data.disabled = true;
            this.updateLine(el.dataset.lineId, quantity - 1)
              .then(() => {
                this.updateCart();
              });
          }
        });
      });

    Array
      .from(this.refs.list.querySelectorAll('.cart-item-quantity-add'))
      .forEach((el) => {
        el.addEventListener('click', () => {
          this.data.disabled = true;
          const quantity = parseInt(el.parentNode.querySelector('.cart-item-quantity-value').textContent, 10);
          this.updateLine(el.dataset.lineId, quantity + 1)
            .then(() => {
              this.updateCart();
            });
        });
      });

    Array
      .from(this.refs.list.querySelectorAll('.cart-item-remove'))
      .forEach((el) => {
        el.addEventListener('click', () => {
          this.data.disabled = true;
          this.removeLine(el.dataset.lineId)
            .then(() => {
              this.updateCart();
            });
        });
      });
  }

  watchCartId(value) {
    if (value && localStorage.getItem('cartId') !== value) {
      localStorage.setItem('cartId', value);
    }
  }

  watchCart(value) {
    if (!value) {
      return;
    }
    if (this.refs.checkoutLink && value?.checkoutUrl) {
      this.refs.checkoutLink.href = value.checkoutUrl;
    }
    if (this.refs.checkoutTotal && value?.estimatedCost?.totalAmount?.amount) {
      this.refs.checkoutTotal.textContent = `${parseFloat(value.estimatedCost.totalAmount.amount).toFixed(2)} €`;
    }

    // console.log(value);

    // reset cart
    this.refs.list.innerHTML = '';
    if (value?.lines?.edges?.length) {
      value.lines.edges.forEach((item) => {
        // console.log(item);
        const options = item.node.merchandise.selectedOptions.map((oItem) => oItem.value).join(' ');
        this.refs.list.innerHTML += `<li class="cart-item">
          <div class="cart-item-remove" data-line-id="${item.node.id}">X</div>
          <div class="cart-item-product">
            <h4>${item.node.merchandise.product.title}</h4>
            <div class="cart-item-options">${options}</div>
            <div class="cart-item-quantity">
              <span class="cart-item-quantity-minus" data-line-id="${item.node.id}">-</span>
              <span class="cart-item-quantity-value">${item.node.quantity}</span>
              <span class="cart-item-quantity-add" data-line-id="${item.node.id}">+</span>
            </div>
          </div>
          <div class="cart-item-price">${parseFloat(item.node.estimatedCost.totalAmount.amount).toFixed(2)} €</div>
          </li>`;
        this.setListeners();
      });
    }
    this.data.disabled = false;
  }
}
